<mat-sidenav-container>
    <mat-sidenav
        *ngIf="!isLogin()"
        class="hidden"
        [ngClass]="{'hidden': isLogin()}"
        [mode]="mode"
        [(opened)]="appStateService.isSideNavOpened">
        <cas-side-nav></cas-side-nav>
    </mat-sidenav>

    <mat-sidenav-content #content [ngClass]="{'desktop': appStateService.isDesktop}">
        <cas-main-toolbar *ngIf="!isLogin()"></cas-main-toolbar>

        <div
            class="main-container"
        >
            <router-outlet #outlet='outlet'></router-outlet>
        </div>

        <ng-container *ngIf="!isLogin() && !appStateService.isDesktop && contextButtonService.showNavPanel">
            <cas-bottom-navigation-panel class="nav-panel">
            </cas-bottom-navigation-panel>
        </ng-container>
    </mat-sidenav-content>
</mat-sidenav-container>
